import React from 'react'
import { store } from '@core/Store'
import { setBetSlipIsOpen } from '@core/Areas/AppHeader/Store'
import {
  MULTI_BUILDER_TOAST_ID,
  MultiBuilderToastContent,
} from '@mobi/betslip/Components/MultiBuilderToastContent/MultiBuilderToastContent'
import { addToast, removeToast } from '@mobi/component-library/Feedback/Toast'
import type { BetSlipItem } from '@mobi/betslip/types'

export const showMultiBuilderToast = (item: BetSlipItem) => {
  addToast({
    timeoutMs: 4000,
    id: MULTI_BUILDER_TOAST_ID,
    component: <MultiBuilderToastContent item={item} />,
  })
}

export const showBetSlipClearedToast = () => {
  const toastText = 'Bet Slip Cleared'
  addToast({
    id: toastText,
    icon: 'success',
    title: toastText,
  })
}

export const showAddedToBetSlipToast = () => {
  const toastText = 'Added to Bet Slip'

  const onBetNowClick = () => {
    removeToast({ id: toastText })
    store.dispatch(setBetSlipIsOpen(true))
  }

  addToast({
    id: toastText,
    title: toastText,
    button: { text: 'Bet Now', onClick: onBetNowClick },
    icon: 'success',
  })
}
